import React from 'react';
import CapitalFilters, { CapitalFiltersState } from './CapitalFilters';
import TopBar from '../../components/Tables/TopBar/TopBar';
import CapitalRow from '../../components/Tables/Capital/CapitalRow';

interface IStock {
    id: number;
    name: string;
    symbol: string;
    amount: string;
    change: string;
    status: number;
    currency: string;
    lineChartData: number[];
    variation_pct: number;
    sector?: string;
    volume_montant?: number;
}

interface DesktopCapitalProps {
    data: IStock[];
    filteredData: IStock[];
    keyword: string;
    setKeyword: (v: string) => void;
    filters: CapitalFiltersState;
    setFilters: (f: CapitalFiltersState) => void;
    favorites: Set<string>;
    onToggleFavorite: (symbol: string, isFav: boolean) => void;
    sectors: string[];
    getVariationLabel: () => string;
}

const DesktopCapital: React.FC<DesktopCapitalProps> = ({
    data,
    filteredData,
    keyword,
    setKeyword,
    filters,
    setFilters,
    favorites,
    onToggleFavorite,
    sectors,
    getVariationLabel,
}) => {
    return (
        <>
            <CapitalFilters
                filters={filters}
                onFiltersChange={setFilters}
                sectors={sectors}
                totalResults={data.length}
                filteredResults={filteredData.length}
            />

            <TopBar
                searchValue={keyword}
                searchOnChange={(e) => setKeyword(e.target.value)}
                searchSubmit={(e) => e.preventDefault()}
            />

            <div className='capital-table-container table-responsive' style={{ margin: '0 20px' }}>
                <table className='data-table' style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th className='left'>Société</th>
                            <th className='center' style={{ minWidth: '100px' }}>Prix</th>
                            <th className='center'>Volume Échangé (Montant)</th>
                            <th className='center'>Variation ({getVariationLabel()})</th>
                            <th aria-label='chart' className='responsive-hide'>Performance</th>
                            <th className='right'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length === 0 ? (
                            <tr>
                                <td colSpan={6} style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                                    Aucune action ne correspond aux critères sélectionnés
                                </td>
                            </tr>
                        ) : (
                            filteredData.map((stock, index) => (
                                <CapitalRow
                                    key={index}
                                    item={stock}
                                    index={index}
                                    isFavorited={favorites.has(stock.symbol)}
                                    onToggleFavorite={onToggleFavorite}
                                />
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default DesktopCapital;
